import React from "react";
import {MainCP}  from "../../../Components/imagen-positiva/imagen-positiva-v2/MainCP"

const ViewImagenPositiva: React.FC = () => <MainCP/>

export default ViewImagenPositiva;